// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FvJu","newExpiryDate":"styles_newExpiryDate__3ib8d","footer":"styles_footer__1XQQm"};